import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function deleteCard(options) {
    const { baseUrl, brandId, country, cardToken, uberToken, clientId, clientSecret } = options;

    invariant(baseUrl, 'baseUrl is a required param of getWallet()');
    invariant(brandId, 'brandId is a required param of getWallet()');
    invariant(country, 'country is a required param of getWallet()');
    invariant(cardToken, 'cardToken is a required param of getWallet()');
    invariant(uberToken, 'uberToken is a required param of getWallet()');
    invariant(clientId, 'clientId is a required param of getWallet()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wallet/card/gps/${cardToken}`;

    return labelRequest(
        authenticatedRequest(new Request(url, { method: 'DELETE', headers: new Headers(headers) }), uberToken, clientId, clientSecret),
        'deleteCard',
    );
}
